/** Stato condiviso frontend — oggetto mutabile per bundle IIFE esbuild */
import { api } from '../api.js';

export { api };

export const C = {
    appHasStarted: false,
    currentUser: null,
    companyInfo: null,
    state: {
        fields: [],
        treatments: [],
        carenzeTreatments: [],
        inventory: [],
        campaigns: [],
        currentCampaignYear: new Date().getFullYear().toString()
    },
    map: undefined,
    mapLayers: {},
    drawPolygonLayer: null,
    currentDrawPoints: [],
    drawMarkers: [],
    savedFieldLayers: [],
    mapCenteredOnUser: false,
    logSianPendingFilter: false,
    fieldSummaryCurrentField: null,
    html5QrcodeScanner: null,
    currentEditingOperatorId: null,
    settingsCertContent: null,
    settingsCertName: null,
    carenzeFilterMode: 'all'
};

export const sampleFields = [
    {
        id: 'f1',
        name: 'Vigneto Nebbiolo (Langhe)',
        crop: 'Vite da vino',
        area: 1.45,
        coords: [
            [44.6198, 7.9935],
            [44.6205, 7.9942],
            [44.6199, 7.9955],
            [44.6190, 7.9945]
        ]
    },
    {
        id: 'f2',
        name: 'Uliveto Collinare',
        crop: 'Olivo',
        area: 0.82,
        coords: [
            [44.6178, 7.9920],
            [44.6185, 7.9928],
            [44.6180, 7.9938],
            [44.6172, 7.9930]
        ]
    }
];

export const sampleInventory = [
    {
        id: 'p1',
        name: 'Poltiglia Bordolese Rameica',
        category: 'Fungicida',
        activeIngredient: 'Rame metallico (20%)',
        barcode: '8001234567890',
        stock: 25.0,
        unit: 'kg'
    },
    {
        id: 'p2',
        name: 'Laser (Spinosad)',
        category: 'Insetticida',
        activeIngredient: 'Spinosad (11.6%)',
        barcode: '8009876543210',
        stock: 3.5,
        unit: 'L'
    },
    {
        id: 'p3',
        name: 'Zolfo Bagnabile',
        category: 'Fungicida',
        activeIngredient: 'Zolfo (80%)',
        barcode: '8004561237890',
        stock: 15.0,
        unit: 'kg'
    },
    {
        id: 'p4',
        name: 'Concime Organo-minerale NPK',
        category: 'Concime',
        activeIngredient: 'NPK 12-12-12',
        barcode: '8007894561230',
        stock: 120.0,
        unit: 'kg'
    }
];

export const sampleTreatments = [
    {
        id: 't1',
        date: (() => {
            const d = new Date();
            d.setDate(d.getDate() - 5);
            return d.toISOString().split('T')[0];
        })(),
        fieldId: 'f1',
        fieldName: 'Vigneto Nebbiolo (Langhe)',
        fieldCrop: 'Vite da vino',
        activityType: 'trattamento',
        product: 'Poltiglia Bordolese Rameica',
        category: 'Fungicida',
        adversity: 'Peronospora',
        safetyDays: 20,
        quantity: 3.6,
        water: 580,
        expiryDate: (() => {
            const d = new Date();
            d.setDate(d.getDate() + 15);
            return d.toISOString().split('T')[0];
        })()
    }
];

export const FRUITETI_CROPS = [
    'Vite da vino', 'Olivo', 'Melo / Frutteto', 'Noccioleto', 'Vigneto',
    'Meleto', 'Pesco', 'Albicocco', 'Ciliegio', 'Altro'
];

export const OPEN_FIELD_CROP_GROUPS = [
    {
        label: 'Ortaggi e tuberi',
        crops: [
            'Patata', 'Carota', 'Cipolla', 'Finocchio', 'Sedano', 'Pomodoro',
            'Zucchina', 'Melanzana', 'Peperone', 'Lattuga / Insalate',
            'Cavolo / Broccoli', 'Fagiolo / Pisello', 'Asparago', 'Barbabietola',
            'Cetriolo', 'Zucca', 'Ravanello', 'Spinacio'
        ]
    },
    {
        label: 'Cereali',
        crops: ['Frumento', 'Grano Tenero', 'Grano Duro', 'Orzo', 'Mais', 'Avena', 'Riso']
    },
    {
        label: 'Foraggere e industriali',
        crops: ['Erba Medica', 'Soia', 'Girasole', 'Colza', 'Erbacee foraggere']
    },
    {
        label: 'Altro',
        crops: ['Altro']
    }
];

export const WMO_CODES = {
    0:  { label: 'Cielo Sereno',           icon: 'fa-sun',               cls: 'text-warning' },
    1:  { label: 'Prevalentemente sereno', icon: 'fa-sun',               cls: 'text-warning' },
    2:  { label: 'Parzialmente nuvoloso',  icon: 'fa-cloud-sun',         cls: 'text-warning' },
    3:  { label: 'Nuvoloso',               icon: 'fa-cloud',             cls: 'text-muted'   },
    45: { label: 'Nebbia',                 icon: 'fa-smog',              cls: 'text-muted'   },
    48: { label: 'Nebbia gelata',          icon: 'fa-smog',              cls: 'text-muted'   },
    51: { label: 'Pioggerella leggera',    icon: 'fa-cloud-drizzle',     cls: 'text-info'    },
    53: { label: 'Pioggerella moderata',   icon: 'fa-cloud-drizzle',     cls: 'text-info'    },
    55: { label: 'Pioggerella intensa',    icon: 'fa-cloud-drizzle',     cls: 'text-info'    },
    61: { label: 'Pioggia leggera',        icon: 'fa-cloud-rain',        cls: 'text-info'    },
    63: { label: 'Pioggia moderata',       icon: 'fa-cloud-rain',        cls: 'text-info'    },
    65: { label: 'Pioggia intensa',        icon: 'fa-cloud-showers-heavy', cls: 'text-info' },
    71: { label: 'Neve leggera',           icon: 'fa-snowflake',         cls: 'text-info'    },
    80: { label: 'Rovesci leggeri',        icon: 'fa-cloud-rain',        cls: 'text-info'    },
    81: { label: 'Rovesci moderati',       icon: 'fa-cloud-showers-heavy', cls: 'text-info' },
    82: { label: 'Rovesci forti',          icon: 'fa-cloud-showers-heavy', cls: 'text-danger'},
    95: { label: 'Temporale',              icon: 'fa-cloud-bolt',        cls: 'text-danger'  },
    99: { label: 'Temporale con grandine', icon: 'fa-cloud-bolt',        cls: 'text-danger'  }
};

export const PERMANENT_CROP_KEYWORDS = [
    'vite', 'olivo', 'melo', 'pero', 'pesco', 'ciliegio', 'noce', 'nocciolo',
    'agrumi', 'ulivo', 'frutteto', 'vigneto', 'oliveto'
];

export const OFFLINE_QUEUE_KEY = 'agrilog_offline_queue';
